// Data-driven content for the 4 consulting packages (Consulenza Essenza / Atelier / Maison / Singolo ambiente).

export const services = {
  "consulenza-essenza": {
    slug: "consulenza-essenza",
    number: "01",
    title: "Consulenza Essenza",
    tagline: "Concept & Space Planning",
    subtitle: "L'intuizione che prende forma.",
    hero_image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=85&auto=format",
    audience_label: "Per chi deve capire come organizzare la casa",
    short_pitch: "Hai una planimetria, ma non sai se gli spazi sono davvero sfruttati bene? Definiamo distribuzione, funzioni, stile e atmosfera prima che inizino i lavori.",
    cta_short: "Scopri Consulenza Essenza",
    intro:
      "La bussola per ridefinire gli spazi e l'anima della tua casa. Hai acquistato casa o vuoi ristrutturare, ma la planimetria attuale non ti convince? Prima di chiamare un'impresa, hai bisogno di una visione chiara. Questo servizio trasforma la confusione iniziale in una direzione estetica e funzionale precisa, ponendo le basi perfette per il tuo progetto.",
    highlights: ["Da 990 €", "2–3 settimane", "Ideale per chi sta acquistando o pianificando"],
    doubts: [
      { title: "Potenziale inespresso", text: "Come posso sfruttare al meglio i metri quadri? Ha senso abbattere quel muro?" },
      { title: "Distribuzione", text: "Come organizzo gli spazi per fluidità e per tutte le esigenze — secondo bagno, cabina armadio?" },
      { title: "Identità visiva", text: "Quale stile, quale palette, quale atmosfera parlano davvero di me?" },
    ],
    included: [
      "Analisi spaziale dello stato di fatto",
      "2 proposte di layout (2D)",
      "Moodboard architettonica con palette e materici",
      "Viste volumetriche 3D di studio",
      "Una revisione inclusa",
      "Book digitale di progetto",
      "Sessione di presentazione in studio o online",
    ],
    excluded: [
      "Render 3D fotorealistici",
      "Elaborati esecutivi (elettrici, idraulici, falegnameria)",
      "Assistenza durante la realizzazione e direzione lavori",
    ],
    timing: "Consegna del Book Essenza entro 2–3 settimane dall'avvio.",
    payment: "50% acconto all'accettazione · 50% a saldo prima della consegna. Carta, PayPal o bonifico.",
    cta: "Prenota Consulenza Essenza",
  },

  "consulenza-atelier": {
    slug: "consulenza-atelier",
    number: "02",
    title: "Consulenza Atelier",
    tagline: "Interior Design Sartoriale",
    subtitle: "Entra nella tua nuova casa prima ancora che esista.",
    hero_image: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=1600&q=85&auto=format",
    audience_label: "Per chi vuole vedere e definire la casa prima di realizzarla",
    short_pitch: "Un progetto d'interni completo con render fotorealistici, arredi su misura, materiali, shopping list e disegni tecnici per trasformare ogni scelta in indicazioni precise.",
    cta_short: "Richiedi il progetto Atelier",
    intro:
      "Un progetto d'interni sartoriale, con arredi su misura e render 3D fotorealistici che trasformano la tua immaginazione in pura realtà visiva. Ogni scelta è cucita su di te, sulle tue abitudini, sul tuo modo di abitare.",
    highlights: ["Preventivo personalizzato", "6–10 settimane", "Il best-seller per chi vuole il wow"],
    doubts: [
      { title: "Immaginare il risultato", text: "Posso vedere la casa finita prima di iniziare i lavori?" },
      { title: "Arredi su misura", text: "Come progettiamo cucina, living e cabina cuciti sui miei spazi?" },
      { title: "Materiali", text: "Come scegliamo materiali di qualità con la giusta anima materica?" },
    ],
    included: [
      "Concept & Space Planning definitivo",
      "Progetto d'interni completo con arredi custom e selezionati",
      "Progetto dell'illuminazione",
      "Render 3D fotorealistici per ogni ambiente principale",
      "Materic sample kit con campioni fisici",
      "Disegni tecnici per falegnami e artigiani",
      "Shopping list dettagliata con fornitori",
      "Book digitale di progetto",
      "Accesso esclusivo a Giovanna Matino Portal — documentazione e materiali di progetto sempre disponibili",
    ],
    excluded: [
      "Pratiche edilizie (SCIA/CILA) e computi metrici",
      "Direzione artistica durante la realizzazione, Direzione Lavori, contabilità e gestione del cantiere",
      "Fornitura fisica dei prodotti (gestita via Shop o preventivo dedicato)",
    ],
    timing: "6–10 settimane in base alla complessità dell'immobile.",
    payment: "40% acconto · 30% alla consegna del progetto esecutivo · 30% a saldo. Carta, PayPal o bonifico.",
    cta: "Prenota Consulenza Atelier",
  },

  "consulenza-maison": {
    slug: "consulenza-maison",
    number: "03",
    title: "Consulenza Maison",
    tagline: "Progetto completo e direzione artistica",
    subtitle: "L'eccellenza architettonica, in ogni dettaglio.",
    hero_image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1600&q=85&auto=format",
    audience_label: "Per chi desidera il progetto completo con affiancamento estetico durante la realizzazione",
    short_pitch: "Il percorso più completo per chi desidera un progetto sviluppato in ogni dettaglio e un affiancamento estetico durante la realizzazione.",
    cta_short: "Parliamo del tuo progetto",
    intro:
      "Maison è il percorso più completo per chi desidera una casa progettata in ogni dettaglio e un affiancamento estetico anche durante la fase realizzativa. Definiamo spazi, materiali, illuminazione, arredi e soluzioni su misura, accompagnandoti negli showroom e nel confronto con fornitori e artigiani per preservare la coerenza del progetto. La direzione artistica verifica che colori, finiture, proporzioni e dettagli interpretino correttamente il concept approvato. Non comprende la Direzione Lavori tecnica, la contabilità di cantiere, il coordinamento della sicurezza o la gestione operativa delle imprese.",
    highlights: ["Preventivo su misura", "4–10 mesi di percorso", "Una visione coerente, dalla progettazione alla realizzazione"],
    doubts: [
      { title: "Scelta dei materiali", text: "Chi mi accompagna nella scelta di materiali e finiture?" },
      { title: "Coerenza estetica", text: "Come garantisco che il risultato rispetti il concept approvato?" },
      { title: "Qualità garantita", text: "Come si tutela ogni finitura con la stessa cura del progetto?" },
    ],
    included: [
      "Tutto il percorso Atelier — progetto completo, render, elaborati tecnici",
      "Affiancamento nella scelta di materiali e finiture",
      "Appuntamenti concordati presso showroom e fornitori",
      "Confronto estetico con fornitori e artigiani",
      "Direzione artistica durante la realizzazione",
      "Verifica della coerenza estetica rispetto al progetto approvato",
      "Accesso esclusivo a Giovanna Matino Portal — documentazione e materiali di progetto sempre disponibili",
    ],
    excluded: [
      "Direzione Lavori tecnica e contabilità di cantiere",
      "Coordinamento della sicurezza e gestione operativa delle imprese",
      "Pratiche edilizie (CILA/SCIA, agibilità) e computi metrici",
      "Lavori edili, impianti, materiali, arredi e forniture",
      "Acquisto dell'immobile e pratiche notarili",
      "Interventi strutturali che richiedono progetto strutturale separato",
    ],
    direction_note: "La direzione artistica riguarda esclusivamente la coerenza estetica e progettuale dell'intervento. Non sostituisce la Direzione Lavori e non comprende controllo tecnico delle opere, contabilità, sicurezza, gestione delle maestranze o responsabilità esecutive di cantiere.",
    timing: "Dai 4 ai 10 mesi in base alla dimensione dell'immobile.",
    payment: "Pagamenti a fasi concordate in fase di offerta.",
    cta: "Prenota Consulenza Maison",
  },
};

export const servicesList = Object.values(services);
